(() => {
  const KEY = "artig_gift_context_v1";
  const $ = (s) => document.querySelector(s);
  const $$ = (s) => Array.from(document.querySelectorAll(s));

  function loadGiftContext() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; }
    catch { return null; }
  }

  function saveGiftContext(gc) {
    localStorage.setItem(KEY, JSON.stringify(gc));
    window.dispatchEvent(new CustomEvent("artig:gift_context_updated", { detail: gc }));
  }

  function clearGiftContext() {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new CustomEvent("artig:gift_context_updated", { detail: null }));
  }

  function openModal() {
    const m = $("#gc-modal");
    if (!m) return;
    m.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
  const m = document.querySelector("#gc-modal");
  if (!m) return;

  // Move focus out of the modal before hiding it (prevents aria-hidden warning)
  if (m.contains(document.activeElement)) {
    document.activeElement.blur();
  }

  m.setAttribute("aria-hidden", "true");
}


  function setStatus(msg) {
    const el = $("#gc-status");
    if (!el) return;
    el.textContent = msg || "";
    if (msg) setTimeout(() => (el.textContent = ""), 1200);
  }

  // Tone chips: max 2
  function getActiveTones() {
    return $$("#gc-tones .gc-chip.is-active").map(b => b.dataset.tone);
  }

  function toggleTone(btn) {
    const active = btn.classList.contains("is-active");
    if (active) {
      btn.classList.remove("is-active");
      return;
    }
    const selected = getActiveTones();
    if (selected.length >= 2) {
      setStatus("Choose up to two tones.");
      return;
    }
    btn.classList.add("is-active");
  }

  function setToneHint() {
    const hint = $("#gc-tone-hint");
    if (!hint) return;
    const selected = getActiveTones();
    hint.textContent = selected.length >= 2 ? "Tone locked (2 selected)." : "";
  }

  // Boldness segmented buttons
  function getBoldness() {
    return $$(".gc-seg-btn.is-active")[0]?.dataset?.bold || "balanced";
  }

  function setBoldness(value) {
    $$(".gc-seg-btn").forEach(b => {
      b.classList.toggle("is-active", b.dataset.bold === value);
    });
  }

  function hydrateFromSaved(saved) {
    $("#gc-name").value = saved?.recipient_name || "";
    $("#gc-relationship").value = saved?.relationship || "";
    $("#gc-occasion").value = saved?.occasion || "";
    $("#gc-price").value = saved?.price_comfort || "flexible";

    // tones
    const set = new Set(saved?.tone_targets || []);
    $$("#gc-tones .gc-chip").forEach(b => {
      b.classList.toggle("is-active", set.has(b.dataset.tone));
    });
    setToneHint();

    // boldness
    setBoldness(saved?.boldness || "balanced");
  }

  function init() {
    const modal = $("#gc-modal");
    if (!modal) return;

    // global open/close
    document.addEventListener("click", (e) => {
      const t = e.target;
      if (t?.closest?.("[data-gc-open]")) { e.preventDefault(); openModal(); }
      if (t?.closest?.("[data-gc-close]")) { e.preventDefault(); closeModal(); }
    });

    // Esc to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });

    // tone chip handlers
    $$("#gc-tones .gc-chip").forEach(btn => {
      btn.addEventListener("click", () => {
        toggleTone(btn);
        setToneHint();
      });
    });

    // boldness handlers
    $$(".gc-seg-btn").forEach(btn => {
      btn.addEventListener("click", () => setBoldness(btn.dataset.bold));
    });

    // restore saved on load
    hydrateFromSaved(loadGiftContext());

    // Save
    $("#gc-save").addEventListener("click", () => {
      const giftContext = {
        recipient_name: $("#gc-name").value || "",
        relationship: $("#gc-relationship").value || "",
        occasion: $("#gc-occasion").value || "",
        tone_targets: getActiveTones(),
        boldness: getBoldness(),
        price_comfort: $("#gc-price").value || "flexible"
      };

      saveGiftContext(giftContext);
      setStatus("Gift Context saved");
      setTimeout(closeModal, 250);
    });

    // Clear
    $("#gc-clear").addEventListener("click", () => {
      clearGiftContext();
      hydrateFromSaved(null);
      setStatus("Gift Context cleared");
    });

    // Expose API
    window.ArtigGiftContext = {
      get: () => loadGiftContext(),
      open: () => openModal(),
      clear: () => clearGiftContext()
    };
  }

  document.addEventListener("DOMContentLoaded", init);
})();
